import React, { useState } from 'react';
import { Layout, Modal } from 'antd';
import LeftBar from '../Organism/LeftBar';
import AppHeader from '../Organism/AppHeader';
import MainContent from './MainContent';
import Progress from '../Molecules/Progress';

interface ReviewLayoutProps {
    subtitle: string;
    stage: string;
    stageName: string;
    verticalMenuItems: Array<{ key: string; title: string; path: string }>;
    currentStage: number;
    onStepClick?: (step: number) => void;
}

const ReviewLayout: React.FC<ReviewLayoutProps> = ({
    subtitle,
    stage,
    stageName,
    verticalMenuItems,
    currentStage,
    onStepClick,
}) => {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [collapsed, setCollapsed] = useState(false);

    const handleStepClick = (step: number) => {
        setIsModalVisible(true);
    };

    // Sidebar width
    const sidebarWidth = collapsed ? 60 : 200;

    return (
        <Layout style={{ minHeight: '100vh', display: 'flex' }}>
            <div
                className={`review-leftbar${collapsed ? ' collapsed' : ''}`}
                style={{
                    position: 'fixed',
                    left: 0,
                    top: 0,
                    height: '100vh',
                    backgroundColor: 'purple',
                    zIndex: 1000,
                    transition: 'width 0.2s, left 0.2s',
                    width: sidebarWidth,
                }}
            >
                {/* Pass collapsed and setCollapsed to LeftBar */}
                <LeftBar menuItems={verticalMenuItems} collapsed={collapsed} setCollapsed={setCollapsed} />
            </div>
            <div
                className="review-main"
                style={{
                    marginLeft: sidebarWidth,
                    flex: '1',
                    display: 'flex',
                    flexDirection: 'column',
                    transition: 'margin-left 0.2s',
                    minHeight: '100vh',
                    position: 'relative',
                    background: '#fff', // optional, for contrast
                }}
            >
                <AppHeader subtitle={subtitle} />
                <div style={{ marginLeft: '30px', marginTop: '10px' }}>
                    <Progress currentStage={currentStage} onStepClick={handleStepClick} />
                </div>
                <MainContent stage={stage} stageName={stageName} />
            </div>
            <style>
                {`
                @media (max-width: 768px) {
                    .review-main {
                        margin-left: 0 !important;
                    }
                    .review-leftbar {
                        width: 60px !important;
                        left: -60px !important; /* Hide sidebar by default on mobile */
                    }
                    .review-leftbar.collapsed {
                        left: 0 !important; /* Show sidebar when not collapsed */
                    }
                }
                `}
            </style>
        </Layout>
    );
};

export default ReviewLayout;